// js/store/index.js (GERENCIADOR DE ESTADO CENTRALIZADO E REATIVO)

class Store {
    constructor() {
        this.state = {
            session: null,
            userProfile: null,
            cart: this.loadCartFromStorage(),
            shippingInfo: this.loadShippingFromSession()
        };
        this.listeners = new Set();
    }

    // Carrega o carrinho inicial do localStorage
    loadCartFromStorage() {
        const CART_KEY = 'runeweave_cart';
        try {
            const cart = localStorage.getItem(CART_KEY);
            return cart ? JSON.parse(cart) : [];
        } catch (e) {
            console.error('[Store] Erro ao carregar carrinho:', e);
            return [];
        }
    }

    // Carrega o frete inicial do sessionStorage
    loadShippingFromSession() {
        try {
            const savedShipping = sessionStorage.getItem('shippingInfo');
            return savedShipping ? JSON.parse(savedShipping) : null;
        } catch (e) {
            return null;
        }
    }

    // Inscreve um callback para ouvir mudanças no estado
    subscribe(callback) {
        this.listeners.add(callback);
        // Retorna a função de cancelamento da inscrição (unsubscribe)
        return () => this.listeners.delete(callback);
    }

    // Notifica todos os ouvintes
    notify() {
        for (const listener of this.listeners) {
            try {
                listener(this.state);
            } catch (e) {
                console.error('[Store] Erro no ouvinte de estado:', e);
            }
        }
    }

    // --- Ações de Modificação de Estado ---

    setSession(session) {
        this.state.session = session;
        this.notify();
    }

    setUserProfile(profile) {
        this.state.userProfile = profile;
        this.notify();
    }

    setCart(cart) {
        this.state.cart = cart;
        const CART_KEY = 'runeweave_cart';
        localStorage.setItem(CART_KEY, JSON.stringify(cart));
        this.notify();
        // Mantém compatibilidade temporária com eventos globais
        window.dispatchEvent(new CustomEvent('cartUpdated'));
    }

    setShippingInfo(shippingInfo) {
        this.state.shippingInfo = shippingInfo;
        if (shippingInfo) {
            sessionStorage.setItem('shippingInfo', JSON.stringify(shippingInfo));
        } else {
            sessionStorage.removeItem('shippingInfo');
        }
        this.notify();
        window.dispatchEvent(new CustomEvent('shippingCalculated', { detail: shippingInfo }));
    }
}

export const globalStore = new Store();
